import http from "axiosSetup";
import { Organisation } from "types/organisation";

/** Matches the API's FluentValidation rule on `route`. */
export const REQUEST_UPGRADE_ROUTE_MAX_LENGTH = 512;

class OrganisationService {
  static get(): Promise<Organisation> {
    return http.get("/users/me/organisation").then((response) => response.data);
  }

  static update(organisation: Pick<Organisation, "name">): Promise<Pick<Organisation, "id">> {
    return http.put("/users/me/organisation", organisation).then((response) => response.data);
  }

  /**
   * Emails the support team a plan-upgrade request for the caller's organisation.
   *
   * The API derives the requester, their role, the organisation and the current
   * plan from the auth token — `route` is the only thing it cannot know, and
   * tells support which page the request came from. Available to org owners and
   * coaches alike. Responds `204` with no body.
   *
   * @see https://github.com/Output-Sports/hub-services/pull/1079
   */
  static requestUpgrade(route: string): Promise<void> {
    return http
      .post("/users/me/organisation/request-upgrade", { route: route.slice(0, REQUEST_UPGRADE_ROUTE_MAX_LENGTH) })
      .then(() => undefined);
  }
}

export default OrganisationService;
